// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1x_7A","label":"Completed_label__1htYz"};